var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcLink40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#335DD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0031 11.9326L26.9293 15.9518V24.0225L20.0222 28.0675L13.0961 24.0546V15.9839L20.0031 11.9326ZM20.0031 6L17.4615 7.48957L10.5417 11.5409L8 13.0305V15.9968V24.061V27.0273L10.5417 28.5041L17.4678 32.5233L20.0095 34L22.5513 32.5104L29.4583 28.4591L32 26.9759V24.0097V15.939V12.9727L29.4583 11.496L22.5322 7.47673L19.9905 6H20.0031Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink40);
export default __webpack_public_path__ + "static/media/ic_link_40.1eae34cfaa873fc147be852d08f47098.svg";
export { ForwardRef as ReactComponent };